import queryKeys from '@/constants/queryKeys';
import { deleteContent } from '@/services/api/requests/content';
import { TCustomAxiosError } from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';

const useDeleteContent = (id: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => deleteContent(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKeys.content.all] });
      toast({ status: 'success', title: 'Success', description: 'Content deleted.' });
      onSuccess?.();
    },
    onError: async (error: TCustomAxiosError) => {
      toast({
        status: 'error',
        title: 'Error deleting content',
        description: error.errors?.[0]?.message,
      });
    },
  });

  return { isPending, mutate };
};

export default useDeleteContent;
